/* eslint-disable sort-keys */
export const mockWorkflowModel = {
    _id: "607e86741b1331fb108396f4",
    name: "Hello Workflow",
    description: "New Workflow, yay!",
    StartDate: "2021-04-20T05:21:06.028Z",
    stages: [
        {
            _id: "sg-vTvJyWsjxigQWjV6JyEN4",
            name: "Stage 1",
            description: "The first stage",
            nextStages: [
                {
                    _id: "sg-ZCBIMty4bAz7YVF1WcwuE",
                    name: "Stage 2"
                }
            ],
            prevStages: [],
            nextStageIds: ["sg-ZCBIMty4bAz7YVF1WcwuE"],
            prevStageIds: [],
            PlannedDuration: "P2WT8H",
            onEnter: {
                explicit_deny: [
                    {
                        subject: "f0d2a99e-86d9-45c4-b284-f7fc790b07bf",
                        kind: "User",
                        permission: "view",
                        scope: "project"
                    }
                ],
                createActions: [
                    {
                        displayname: null,
                        name: "My action 1",
                        kind: "APPROVE",
                        displaytype: null,
                        description: null,
                        identifier: null,
                        subject: [
                            {
                                id: "76efa4f1-c8b1-4b2f-ad93-3acf4f75d912",
                                kind: "User"
                            }
                        ],
                        sendNotification: true,
                        customstati: [ "Approve", "Send to Done" ]
                    },
                ]
            },
            defaultActionType: "APPROVE",
            entryguards: [],
            exitguards: [
                {
                    nextStage: "sg-ZCBIMty4bAz7YVF1WcwuE",
                    conditions: [
                        {
                            assertation: {
                                __typename: "ActionAssertation",
                                customstatus: "Approve",
                                type: "APPROVE",
                                status: "FULFILLED"
                            }
                        },
                    ]
                },
                {
                    nextStage: "sg-ZCBIMty4bAz7YVF1WcwuE",
                    conditions: [
                        {
                            assertation: {
                                __typename: "ActionAssertation",
                                customstatus: "Send to Done",
                                type: "APPROVE",
                                status: "REJECTED"
                            }
                        },
                    ]
                }
            ],
            autoprogress: []
        },
        {
            _id: "sg-ZCBIMty4bAz7YVF1WcwuE",
            name: "Stage 2",
            description: null,
            nextStages: [
                {
                    _id: "sg-vTvJyWsjxigQWjV6JyEN4",
                    name: "Stage 1"
                }
            ],
            prevStages: [],
            nextStageIds: ["sg-vTvJyWsjxigQWjV6JyEN4"],
            prevStageIds: [],
            PlannedDuration: null,
            onEnter: {
                explicit_deny: [],
                createActions: [
                    {
                        displayname: null,
                        name: "My action 2",
                        kind: "APPROVE",
                        displaytype: null,
                        description: null,
                        identifier: null,
                        subject: [
                            {
                                id: "76efa4f1-c8b1-4b2f-ad93-3acf4f75d912",
                                kind: "User"
                            }
                        ],
                        sendNotification: true,
                        customstati: [ "Done", "Send back" ]
                    },
                ]
            },
            defaultActionType: "APPROVE",
            entryguards: [],
            exitguards: [
                
                {
                    nextStage: "sg-vTvJyWsjxigQWjV6JyEN4",
                    conditions: [
                        {
                            assertation: {
                                __typename: "ActionAssertation",
                                customstatus: "Done",
                                type: "APPROVE",
                                status: "FULFILLED"
                            }
                        },
                    ]
                },
                {
                    nextStage: "sg-vTvJyWsjxigQWjV6JyEN4",
                    conditions: [
                        {
                            assertation: {
                                __typename: "ActionAssertation",
                                customstatus: "Send back",
                                type: "APPROVE",
                                status: "REJECTED"
                            }
                        },
                    ]
                }
            ],
            autoprogress: []
        }
    ],
};
